// extracted by mini-css-extract-plugin
module.exports = {"heading":"TermsOfServicePage_heading__2v-2k","content":"TermsOfServicePage_content__1Y4dY"};